import { LUDUM_USER_ROLES } from '@/constants';
import { isDayOffSession, isMultisportSession, isOtherSession, isWaterSession } from '@/helpers/sessionHelper';
import get from 'get-object-path';

export const sessionDetails = {
    namespaced: true,

    state: {
        session: null,
        healthStatuses: []
    },

    mutations: {
        emptySession(state) {
            state.session = null;
        },

        sessionSave(state, data) {
            state.session = data;
        },

        healthStatuses(state, data) {
            state.healthStatuses = [...data];
        }
    },

    getters: {
        sessionHealthStatuses(state) {
            return state.healthStatuses;
        },

        session(state) {
            return state.session;
        },

        isEvent(state) {
            return !get(state, 'session.session_id');
        },

        sportId(state) {
            return get(state, 'session.sport.id');
        },

        sportName(state) {
            return get(state, 'session.sport.name');
        },

        canEditSession(state) {
            return get(state, 'session.user_actions.data.edit');
        },

        canAddAllResults(state) {
            return get(state, 'session.user_actions.data.add_all_scores');
        },

        showViewResults(state, getters) {
            return !isDayOffSession(getters.sportId) && !isMultisportSession(getters.sportId);
        },

        showAddScoreButton(state, getters) {
            if (!getters.eligibleToAddScore || getters.isEvent) {
                return false;
            }

            if (isWaterSession(getters.sportId)) {
                return getters.canAddAllResults;
            }

            return getters.userIsAthlete || getters.canAddAllResults;
        },

        eligibleToAddScore(state, getters) {
            return !isOtherSession(getters.sportId)
                && !isDayOffSession(getters.sportId)
                && !isMultisportSession(getters.sportId);
        },

        userSessionRoleId(state) {
            return get(state, 'session.attendance.data.user_role.data.id');
        },

        userIsAthlete(state, getters) {
            return getters.userSessionRoleId === LUDUM_USER_ROLES.ATHLETE;
        },

        userIsCoach(state, getters) {
            return [LUDUM_USER_ROLES.COACH, LUDUM_USER_ROLES.HEAD_COACH].includes(getters.userSessionRoleId);
        },

        showImportData(state, getters) {
            return !getters.isEvent && (getters.userIsAthlete || isWaterSession(getters.sportId));
        }
    },

    actions: {
        getSession(context, payload) {
            return context.dispatch(
                'get',
                {
                    url: api + 'session/' + payload.id,
                    params: {
                        include: ['session,user_actions,attendance.training_load_score', payload.include]
                            .filter(Boolean)
                            .join()
                    }
                },
                { root: true }
            );
        },

        getHealthStatuses(context) {
            return context.dispatch(
                'get',
                {
                    url: api + 'not-attending-heath-options'
                },
                { root: true }
            );
        }
    }
};
